const SvgModernize4 = (props) => (
  <>
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M96 379.75v-87.5M96 96.25v-96M96 196.25v88M96 96.25v92M92.95 380.95 0 288h92M99.05 380.95 192 288h-92M100 192h92l-93.17 93.17M92 192H0l93.17 93.17M98.83 189.17 192 96H96M96 96H0l93.17 93.17M96 284c-1.1 0-2.1.45-2.83 1.17"
    />
    <path
      d="M96 292c2.21 0 4-1.79 4-4M93.17 285.17A3.99 3.99 0 0 0 92 288M92 288c0 2.21 1.79 4 4 4M100 288c0-1.1-.45-2.1-1.17-2.83M96 284c1.1 0 2.1.45 2.83 1.17M96 380c1.23 0 2.32.57 3.05 1.45M96 380c-1.23 0-2.32.57-3.05 1.45M92.95 381.45c-.58.7-.95 1.58-.95 2.55 0 2.21 1.79 4 4 4s4-1.79 4-4c0-.98-.36-1.86-.95-2.55M93.17 189.17A3.99 3.99 0 0 0 92 192M100 192c0 2.21-1.79 4-4 4M100 192c0-1.1-.45-2.1-1.17-2.83M93.17 189.17A3.99 3.99 0 0 1 96 188M96 196c-2.21 0-4-1.79-4-4M98.83 189.17A3.99 3.99 0 0 0 96 188"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
  </>
);

export default SvgModernize4;
